import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  finalizeResubscription,
  registerUserRegular,
  finalizeRegistration,
  determineRegistration,
  registerUserInvitation,
  registerNewSpace,
} from "../../networking/registration/networking";
import * as types from "../types/registration";

function* validateRegularFirstStep(action) {
  try {
    var response = yield call(registerUserRegular, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_GENERAL_VERIFICATION,
        data: response.payload,
      });
    } else {
      throw response.error;
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_GENERAL_VERIFICATION, message: errMessage });
  }
}

function* validateRegularFinalStep(action) {
  try {
    if (action.details) {
      var response = yield call(finalizeRegistration, action.details);
      if (response.error === null) {
        yield put({
          type: types.GRANT_FINALIZE_REGISTRATION,
          payload: response.payload,
        });
      } else {
        throw new Error("Kunne ikke fullføre registrering.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FINALIZE_REGISTRATION, message: e });
  }
}

function* validateCanRegister(action) {
  try {
    if (action.details) {
      var response = yield call(determineRegistration, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_CAN_REGISTER });
      } else {
        throw new Error("Bruker er allerede registrert.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CAN_REGISTER, message: e });
  }
}

function* registerInvitation(action) {
  try {
    var response = yield call(registerUserInvitation, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_INVITATION_REGISTRATION,
        data: response.payload,
      });
    } else {
      throw new Error("Kunne ikke fullføre registrering.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_INVITATION_REGISTRATION, message: e });
  }
}

function* validateNewSpaceStep(action) {
  try {
    var response = yield call(registerNewSpace, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_NEW_SPACE_REGISTRATION,
        data: response.payload,
      });
    } else {
      throw new Error("Kunne ikke fullføre registrering.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_NEW_SPACE_REGISTRATION, message: e.error });
  }
}

function* validateResubscription(action) {
  try {
    var response = yield call(finalizeResubscription, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_RESUBSCRIBE_REGISTRATION,
        data: response.payload,
      });
    } else {
      throw new Error("Kunne ikke fullføre registrering.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_RESUBSCRIBE_REGISTRATION, message: e });
  }
}

function* registrationSaga() {
  yield all([
    takeEvery(types.REQUEST_GENERAL_VERIFICATION, validateRegularFirstStep),
    takeEvery(types.REQUEST_FINALIZE_REGISTRATION, validateRegularFinalStep),
    takeEvery(types.REQUEST_CAN_REGISTER, validateCanRegister),
    takeEvery(types.REQUEST_INVITATION_REGISTRATION, registerInvitation),
    takeEvery(types.REQUEST_NEW_SPACE_REGISTRATION, validateNewSpaceStep),
    takeEvery(types.REQUEST_RESUBSCRIBE_REGISTRATION, validateResubscription),
  ]);
}

export default registrationSaga;
